/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-console */
import { useCallback, useEffect, useRef, useState } from 'react';
import { iTHREE, GameLockPathModal } from '@treedis/tour-loader';
import { useTheme } from 'styled-components';
import { useBasicStore, useUIStore } from 'store';
import DesktopSwitchPath from 'components-new/eCommerce/DesktopSwitchPath';
import { confirmAlert } from 'react-confirm-alert';
import {
  EntityType,
  GameLock,
  GameLockPath,
  GameLockPathTransitionType,
  LockLocationType,
} from '@/_models/Game';
import { TourImage, TourObject, TourVideo } from '@/_models/virtualStaging/VSObject';
import { ChapterType } from '@/_models/game/GameBook';
import { useGlobalDOMEvents } from '@/hooks/index';
import { Props } from './types';
import { asyncStore, handlePathDelay, parsePathDestinationSweepData } from '@/_helpers/base';
import { color } from '@/utils/index';

import 'react-confirm-alert/src/react-confirm-alert.css';

const pathSnapshot = asyncStore?.pathSnapshot;
let skipPathTo;

export const RegularPaths = ({
  showcase,
  gamePaths,
  allTags,
  polygons,
  vsObjects,
  sweeps,
  currentSweep,
  clickedElement,
  translation,
  gameId,
  onAction,
  isRtl,
  // panoIsOpen,
  __hideItems,
  __revealItems,
  hideElements,
  showElements,
  pathfinderDataState,
  setPathfinderDataState,
}: Props) => {
  const [lockPath, setLockPath] = useState(null);
  const currentPathStep = useRef<any>(null);
  const paths = useRef(new Map());
  // @ts-ignore
  const [isFinish, setIsFinish] = useState<boolean>(false);
  const [finishedPaths, setFinishedPaths] = useState<number[]>([]);
  const [delayedDisable, setDelayedDisable] = useState(true);
  const [isEnablePreviousStep, setIsEnablePreviousStep] = useState<boolean>(false);
  const [_, setUpdateState] = useState<boolean>(false);
  const forceShowPathSwitchMobileModal = useBasicStore((state) => state.forceShowPathSwitchMobileModal);
  const setForceShowPathSwitchMobileModal = useBasicStore((state) => state.setForceShowPathSwitchMobileModal);
  const bottomBarOpen = useUIStore((state) => state.bottomBarOpen);
  const tourConfigs = useBasicStore((state) => state.tourConfigs);
  const theme = useTheme();
  const tagRefForData = useRef<any>();
  tagRefForData.current = { lockPath, allTags };
  asyncStore.currentPathStep = currentPathStep.current;

  useEffect(() => {
    if (currentPathStep?.current?.triggerItem !== -1 && currentPathStep?.current?.triggerType) {
      setIsEnablePreviousStep(lockPath?.previousStep);
    } else {
      setIsEnablePreviousStep(false);
    }
  }, [currentPathStep?.current]);

  useGlobalDOMEvents(
    {
      keyup: async (ev: KeyboardEvent) => {
        if (ev.code === 'Space') {
          // eslint-disable-next-line no-use-before-define
          await handleNextStep();
        }
      },
    },
    [vsObjects, allTags],
  );

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const goToNextStep = async (forcedLockPath?: GameLock) => {
    const _lockPath = forcedLockPath || lockPath || tagRefForData.current?.lockPath;
    const nextStep = currentPathStep?.current?.next;
    const delay = parseInt(nextStep?.appearanceDelay);
    const nextStepId: string = nextStep?.id;

    if (nextStepId && paths.current.has(nextStepId)) {
      const step = paths?.current?.get(nextStepId);
      if (_lockPath?.hideItems) {
        const allTagsArray = Array.from(allTags, ([, value]: any) => value);
        const tagsToReveal =
          step.locationType === EntityType.Tag
            ? allTagsArray.filter(
                (tag) =>
                  tag?.id === step.locationItem ||
                  tag.sid === step.locationItem ||
                  tag.defaultSid === step.locationItem,
              )
            : [];
        const polygonsToReveal =
          step.locationType === EntityType.Polygon
            ? polygons.filter(
                (polygon) =>
                  polygon.id === step.locationItem || polygon.id?.toString() === step.locationItem,
              )
            : [];
        const vsImagesToReveal =
          step.locationType === EntityType.VSImage
            ? vsObjects.filter(
                (object) =>
                  object instanceof TourImage &&
                  (object.id === step.locationItem || object.id?.toString() === step.locationItem),
              )
            : [];
        const vsVideosToReveal =
          step.locationType === EntityType.VSVideo
            ? vsObjects.filter(
                (object) =>
                  object instanceof TourVideo &&
                  (object.id === step.locationItem || object.id?.toString() === step.locationItem),
              )
            : [];
        const vsItemsToReveal =
          step.locationType === EntityType.VSItem
            ? vsObjects.filter(
                (object) =>
                  object instanceof TourObject &&
                  (object.id === step.locationItem || object.id?.toString() === step.locationItem),
              )
            : [];

        await showElements({
          tagsToReveal: tagsToReveal.map((e) => e?.defaultSid || e?.sid),
          polygonsToReveal: polygonsToReveal.map((e) => e?.id?.toString()),
          vsImagesToReveal: vsImagesToReveal.map((e) => e?.id?.toString()),
          vsVideosToReveal: vsVideosToReveal.map((e) => e?.id?.toString()),
          vsItemsToReveal: vsItemsToReveal.map((e) => e?.id?.toString()),
        });
      }

      if (currentPathStep?.current?.hideStep) {
        // hide clicked element
        __hideItems([
          {
            conditionType: 'hide',
            entity_type: currentPathStep?.current?.locationType,
            entity_ids: [currentPathStep?.current?.locationItem],
          },
        ]);
      }
      const prevStep = currentPathStep?.current;
      currentPathStep.current = step;
      // if delay then path will appear with timeout / reset previous timeout
      handlePathDelay(delay, setDelayedDisable);
      if (skipPathTo && skipPathTo !== prevStep.id) {
        goToNextStep(_lockPath);
      } else {
        skipPathTo = null;
      }
    } else {
      skipPathTo = null;
      const newFinishedPaths = [...finishedPaths, _lockPath?.id];
      // check if there is another uncomoleted paths?
      // const unfinishedPaths = gamePaths.filter((path) => !newFinishedPaths.includes(path.id));
      // if (unfinishedPaths.length > 0) {
      //   _changePath(unfinishedPaths[0].id);
      // } else {
      //   setIsFinish(true);
      // }
      currentPathStep.current = null;
      paths.current = null;
      asyncStore.pathIds = [];
      // console.debug('aaa setLockPath null 3');
      setLockPath(null);

      setFinishedPaths(newFinishedPaths);
    }
    // force update of path, because it's using data from reference which is not updating it's Reference
    setUpdateState((updateState) => !updateState);
  };

  const goToPreviousStep = async () => {
    const prevStepId: string = currentPathStep?.current?.prev?.id;
    if (prevStepId) {
      const step = paths?.current?.get(prevStepId);
      if (step?.hideStep) {
        // reveal previous hidden element
        __revealItems([
          {
            conditionType: 'reveal',
            entity_type: step?.locationType,
            entity_ids: [step?.locationItem],
          },
        ]);
      }
      currentPathStep.current = step;
    } else {
      setIsEnablePreviousStep(false);
    }
  };

  // @ts-ignore commented debug
  const belongToCurrentPath = () => {
    let _skipPathTo;
    if (lockPath?.allowSkipping) {
      let safeCycle = 1000; // prevent infinite loop if linked to itself or recursive
      let currentStep = currentPathStep?.current;

      while (safeCycle > 0 && currentStep && !_skipPathTo) {
        if (
          (currentStep?.locationItem?.toString() === clickedElement.id.toString() ||
            currentStep?.locationItem?.toString() === clickedElement?.sid ||
            currentStep?.locationItem?.toString() === clickedElement?.defaultSid) &&
          currentStep?.locationType === clickedElement.type
        ) {
          _skipPathTo = currentStep.id;
        }
        currentStep = paths.current?.get(currentStep?.next?.id);
        safeCycle--;
      }
      if (_skipPathTo) {
        skipPathTo = _skipPathTo;
        goToNextStep();
        return true;
      }
    } else {
      // also check if it's belong to future steps & allowSkipping enabled
      if (
        (currentPathStep?.current?.locationItem?.toString() === clickedElement.id.toString() ||
          currentPathStep?.current?.locationItem?.toString() === clickedElement?.sid ||
          currentPathStep?.current?.locationItem?.toString() === clickedElement?.defaultSid) &&
        currentPathStep?.current?.locationType === clickedElement.type
      ) {
        goToNextStep();
        return true;
      }
      return false;
    }
  };

  useEffect(() => {
    if (gamePaths && gamePaths?.length) {
      if (gamePaths.length === 1) {
        asyncStore.regularActivePath = 0;
        setLockPath(gamePaths[0]);
      }
    }
  }, [gamePaths]);

  const createPath = (
    items: Map<string | number, unknown>,
    triggerType: LockLocationType,
    triggerItem: number,
  ) => {
    const step = lockPath?.paths?.find(
      (path) =>
        path.triggerType === triggerType &&
        (path.triggerItem === triggerItem || (path.triggerItem === null && triggerItem === -1)),
    ) as GameLockPath & { element: any };
    if (!step) return items;

    const next = lockPath?.paths.find(
      (path) => path.triggerType === step.locationType && path.triggerItem === step.locationItem,
    );
    const prev = lockPath?.paths.find(
      (path) => path.locationType === step.triggerType && path.locationItem === step.triggerItem,
    );
    if (!triggerType) {
      currentPathStep.current = {
        ...step,
        prev: prev || null,
        next: next && next.id !== step.id ? next : null,
      };
      const delay = parseInt(step?.appearanceDelay?.toString());

      // if delay then path will appear with timeout / reset previous timeout
      handlePathDelay(delay, setDelayedDisable);
    }
    items.set(step.id, {
      ...step,
      prev: prev || null,
      next: next && next.id !== step.id ? next : null,
    });
    asyncStore.pathIds.push(step.id);
    return next && !items.get(next.id)
      ? createPath(items, next.triggerType, next.triggerItem)
      : items;
  };

  const rotateCameraTo = async (t) => {
    try {
      if (asyncStore.vrIsOn) return console.error('Camera rotate is disabled for VR mode');
      const THREE = await iTHREE();
      const l = (value) => (value * Math.PI) / 180;
      const d = new THREE.Vector3(0, 0, -1);
      const a = await showcase.mpSDK.Camera.getPose();
      const r = new THREE.Euler(l(a.rotation.x), l(a.rotation.y), 0, 'XYZ');
      const o = d.clone().applyEuler(r);
      const s = new THREE.Vector3(a.position.x, a.position.y, a.position.z);
      const u = t.clone();
      const f = o.clone().normalize();
      const p = u.clone().sub(s).normalize();
      const m = new THREE.Vector3(f.x, 0, f.z);
      const b = new THREE.Vector3(p.x, 0, p.z);
      const h = m.angleTo(b);
      const g = f.x * p.z - f.z * p.x < 0 ? -1 : 1;
      await showcase.mpSDK.Camera.rotate(((180 * h) / Math.PI) * g);
    } catch (err) {
      console.error(err);
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const moveToPathStepElement = async (type: ChapterType, value: number | string) => {
    // check if sweep set by point or smart link and return it
    const destinationSweepData = parsePathDestinationSweepData(currentPathStep?.current);
    const pathSweep = sweeps.find(
      (sweep) =>
        destinationSweepData?.sweepUuid === sweep.uuid ||
        destinationSweepData?.sweepUuid === sweep.sid ||
        destinationSweepData?.sweepUuid === sweep.sweep_uuid,
    );

    let obj: any;
    switch (type) {
      case ChapterType.Tag: {
        const allTagsArray = Array.from(allTags, ([, v]: any) => v);
        obj = allTagsArray?.find(
          (item) => value === item?.id || value === item?.defaultSid || value === item?.sid,
        );
        break;
      }
      case ChapterType.Polygon: {
        obj = polygons.find((item) => value === item.id || value === item.id?.toString());
        break;
      }
      case ChapterType.VSImage: {
        obj = vsObjects.find(
          (item) =>
            item instanceof TourImage && (value === item.id || value === item.id?.toString()),
        );
        break;
      }
      case ChapterType.VSVideo: {
        obj = vsObjects.find(
          (item) =>
            item instanceof TourVideo && (value === item.id || value === item.id?.toString()),
        );
        break;
      }
      case ChapterType.VSItem: {
        obj = vsObjects.find(
          (item) =>
            item instanceof TourObject && (value === item.id || value === item.id?.toString()),
        );
        break;
      }
      default:
        break;
    }
    if (obj && pathSweep) {
      const THREE = await iTHREE();
      const transitionType =
        currentPathStep?.current?.transitionType || GameLockPathTransitionType.INSTANT;
      await showcase.mpSDK.Sweep.moveTo(pathSweep.uuid, {
        transition: showcase.mpSDK.Sweep.Transition[transitionType?.toUpperCase()],
      });
      if (!asyncStore.vrIsOn) {
        if (destinationSweepData.isTourLink) {
          showcase.mpSDK?.Camera.setRotation({
            x: destinationSweepData.x,
            y: destinationSweepData.y,
          });
        } else {
          await rotateCameraTo(new THREE.Vector3(obj.positionX, obj.positionY, obj.positionZ));
        }
      }
    }
    return obj;
  };

  const handleNextStep = useCallback(async () => {
    if (!currentPathStep?.current) return;
    if (currentPathStep?.current.sweepUuid === currentSweep.uuid) {
      await goToNextStep();
    }
    const vsElement = await moveToPathStepElement(
      currentPathStep?.current?.locationType,
      currentPathStep?.current?.locationItem,
    );
    if (currentPathStep?.current?.autoOpenDestination) {
      onAction(vsElement, currentPathStep.current.locationType);
    }
  }, [moveToPathStepElement]);

  const handlePreviousStep = async () => {
    await goToPreviousStep();
    const vsElement = await moveToPathStepElement(
      currentPathStep?.current?.locationType,
      currentPathStep?.current?.locationItem,
    );
    if (currentPathStep?.current?.autoOpenDestination) {
      onAction(vsElement, currentPathStep.current.locationType);
    }
  };

  useEffect(() => {
    (async () => {
      if (lockPath && !paths.current?.size) {
        asyncStore.pathIds = [];
        paths.current = createPath(new Map(), null, -1);
        let pathArray = Array.from(paths.current, ([, value]: any) => value);
        pathArray = pathArray.filter((e) => e.id !== currentPathStep?.current?.id);
        if (lockPath?.hideItems) {
          await hideElements({
            hideTags: pathArray
              .filter((v) => v.locationType === EntityType.Tag)
              .map((e) => e?.locationItem),
            polygonsToHide: pathArray
              .filter((v) => v.locationType === EntityType.Polygon)
              .map((e) => e?.locationItem),
            vsImagesToHide: pathArray
              .filter((v) => v.locationType === EntityType.VSImage)
              .map((e) => e?.locationItem),
            vsVideosToHide: pathArray
              .filter((v) => v.locationType === EntityType.VSVideo)
              .map((e) => e?.locationItem),
            vsItemsToHide: pathArray
              .filter((v) => v.locationType === EntityType.VSItem)
              .map((e) => e?.locationItem),
          });
        }
        if (skipPathTo) {
          goToNextStep();
        } else {
          // screen render update, because changing ref not trigger rerender
          setUpdateState((updateState) => !updateState);
        }
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lockPath, handleNextStep, paths?.current, skipPathTo]);

  const _changePath = (pathId: number | string, restart?: boolean) => {
    if (pathId == lockPath?.id) return;
    let skipChangePath = false;
    const path = gamePaths.find((p) => p.id === pathId || p.id?.toString() === pathId);
    // save current path to restore later
    pathSnapshot[lockPath?.id] = {
      currentPathStep: currentPathStep.current,
      paths: paths.current,
      pathIds: asyncStore.pathIds,
    };

    if (pathSnapshot[pathId] && !restart) {
      // set stored path as current
      currentPathStep.current = pathSnapshot[pathId]?.currentPathStep;
      paths.current = pathSnapshot[pathId]?.paths;
      asyncStore.pathIds = pathSnapshot[pathId]?.pathIds;
      if (skipPathTo) {
        skipChangePath = true;
        goToNextStep(path);
      }
    } else {
      currentPathStep.current = null;
      paths.current = null;
      asyncStore.pathIds = [];
    }
    if (!skipChangePath) {
      // console.debug('aaa setLockPath _changePath 2', path);
      setLockPath(path);
    }
    asyncStore.regularActivePath = gamePaths.map((p) => p.id).indexOf(path.id);
  };

  const askForReset = (pathId) => {
    confirmAlert({
      title: '',
      message:
        translation.restartPath || 'Do you wish to restart this path or continue where you left?',
      buttons: [
        {
          label: translation.restart || 'Restart',
          onClick: () => {
            skipPathTo = null;
            _changePath(pathId, true);
          },
        },
        {
          label: translation.continue || 'Continue',
          onClick: () => {
            _changePath(pathId);
          },
        },
      ],
    });
  };

  const handleChangePath = (ev: any) => {
    if (lockPath?.id === ev.target.value) return;
    const targetPath = gamePaths.find(
      (p) => p.id === ev.target.value || p.id?.toString() === ev.target.value,
    );
    confirmAlert({
      title: '',
      message:
        translation.switchPath ||
        'Are you sure you wish to begin a new path? The current path will be turned off',
      buttons: [
        {
          label: translation.yes || 'Yes',
          onClick: () => {
            const pathId = ev.target.value;
            if (targetPath?.pathSetting?.resetPathOnSwitch) {
              setTimeout(() => {
                askForReset(pathId);
              }, 1000);
            } else {
              _changePath(pathId);
            }
          },
        },
        {
          label: translation.no || 'No',
          onClick: () => {
            skipPathTo = null;
          },
        },
      ],
    });
  };

  // console.debug('aaa -----------------------------------------------------------------------');
  // console.debug('aaa game', game);
  // console.debug('aaa lockPath', lockPath);
  // console.debug('aaa finishedPaths', finishedPaths);
  // console.debug('aaa currentPathStep.current', currentPathStep.current);
  // console.debug('aaa paths.current', paths.current);
  // console.debug('aaa asyncStore.pathIds', asyncStore.pathIds);
  // console.debug('aaa isShowPathLockByExperience && showPathLock', isShowPathLockByExperience, showPathLock);

  return (
    <>
      {!isFinish && (
        <DesktopSwitchPath
          finishedPaths={finishedPaths}
          gameId={gameId}
          pathLocks={gamePaths}
          pathLockId={lockPath?.id}
          currentPathStepId={currentPathStep?.current?.id}
          handleChangePath={handleChangePath}
        />
      )}
      {!isFinish && (
        <GameLockPathModal
          finishedPaths={finishedPaths}
          forceShowPathSwitchMobileModal={forceShowPathSwitchMobileModal}
          setForceShowPathSwitchMobileModal={setForceShowPathSwitchMobileModal}
          handleChangePath={handleChangePath}
          pathLocks={gamePaths}
          APP_AWS={process.env.NEXT_PUBLIC_CDN}
          bottomBarOpen={bottomBarOpen}
          tourConfigs={tourConfigs}
          asyncStore={asyncStore}
          theme={theme}
          color={color}
          pathSnapshot={pathSnapshot}
          currentPathStepId={currentPathStep?.current?.id}
          pathfinderDataState={pathfinderDataState}
          setPathfinderDataState={setPathfinderDataState}
          delayedDisable={delayedDisable}
          isRtl={isRtl}
          pathLockId={lockPath?.id}
          gameId={gameId}
          pathSettings={lockPath?.pathSetting || {}}
          handleNextStep={handleNextStep}
          handlePreviousStep={handlePreviousStep}
          translation={translation}
          title={currentPathStep?.current?.title}
          description={currentPathStep?.current?.description}
          isEnablePreviousStep={isEnablePreviousStep && lockPath?.previousStep}
          // @ts-ignore property added to types
          isEnableNextStep
          // @ts-ignore
          buttonOnlyMode={lockPath?.buttonOnlyMode}
          nextButtonVisibility={lockPath?.nextButtonVisibility}
          // @ts-ignore property added to types
          icon={currentPathStep?.current?.icon}
        />
      )}
    </>
  );
};
